
	import Vue from "vue";

	import axios from "axios";
	import * as $ from "jquery";
	import moment from "moment";
	import helpers from "../inc/helpers";

	import CalculateYourTaxesDetail from "../components/CalculateYourTaxesDetail.vue";
	import LevyEstimatorDetail from "../components/LevyEstimatorDetail.vue";
	import HomesteadExemptionDetail from "../components/HomesteadExemptionDetail.vue";
	import SchoolDistrictEstimateDetail from "../components/SchoolDistrictEstimateDetail.vue";
	import OwnerOccupancyCreditDetail from "../components/OwnerOccupancyCreditDetail.vue";
	import ReevaluationDetail from "../components/ReevaluationDetail.vue";

	import TaxInfo from "../data/TaxInfo";
	import TaxLookup from "../data/TaxLookup";

	interface SearchRequestBody {
		address: null | string;
		last_name: null | string;
		parcel_id: null | string;
	}

	export default Vue.extend({
		props: {
			lookupType: String,
			disclaimer: String,
			note: String,
			headline: String,
		},

		data() {
			return {
				parcel_id: null as null | string,
				parcelLookup: null as null | TaxLookup,
				form: {
					isSearching: false,
					fields: {
						address: null,
						last_name: null,
						parcel_id: null,
					} as SearchRequestBody,
					results: null as null | Array<TaxInfo>,
					error: null as null | string,
				},
			};
		},

		mounted() {
			var url = new URL(window.location.href);

			if (!!url.searchParams.has("parcel_id")) {
				this.parcel_id = url.searchParams.get("parcel_id") as null | string;
			}
		},

		methods: {
			submitForm() {
				if (this.isSearchReady) {
					this.form.isSearching = true;

					this.resetForm();

					const endpoint = "https://datastore.geaugaconnected.com/wp-json/ds/v1/b4e44425b3b297f4143ea42b617a929d/o/parcel-mapping-lookup";

					axios.post(endpoint, this.searchRequest).then((resp: any) => {
						if (resp.status === 200 && !!resp.data.data.length) {
							let results = this.filterResults(resp.data.data);

							if (!!results?.length) {
								this.form.results = results;
							} else {
								this.form.error = "Sorry, no parcels match your search. Please verify that it is correct and try again.";
							}
						} else {
							this.form.error = "Sorry, having trouble finding a parcel with that information. Please verify that it is correct and try again.";
						}

						this.form.isSearching = false;
					});
				} else {
					alert("You must fill out at least one field");
				}
			},

			clearForm() {
				this.form.fields.address = null;
				this.form.fields.last_name = null;
				this.form.fields.parcel_id = null;

				this.resetForm();
			},

			resetForm() {
				this.form.results = null;
				this.form.error = null;
			},

			openDetail(parcel_id: string, property_id: string) {
				if (this.lookupType === "levy") {
					this.parcel_id = parcel_id;
				} else {
					const openURL = `https://realestate.geauga.oh.gov/RealEstate/Summary?property_Id=${property_id}`;
					window.open(openURL, "_blank");
				}
			},

			backToSearch() {
				var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
				window.history.pushState({ path: newurl }, "", newurl);

				this.parcel_id = null;
			},

			filterResults(results: Array<TaxInfo>): null | Array<TaxInfo> {
				const { address, last_name, parcel_id } = this.form.fields;

				if (!!address) {
					return results.filter((result: TaxInfo) => result.Location_a.includes(address!.toString().toUpperCase()));
				} else if (!!last_name) {
					return results.filter((result: TaxInfo) => result.L_name.includes(last_name!.toString().toUpperCase() + " "));
				}

				return results;
			},
		},

		computed: {
			lastYear(): string {
				return moment()
					.subtract(1, "year")
					.format("Y");
			},

			thisYear(): string {
				return moment().format("Y");
			},

			isSearchReady(): boolean {
				return this.form.fields.address !== null || this.form.fields.last_name !== null || this.form.fields.parcel_id !== null;
			},

			searchRequest(): SearchRequestBody {
				return {
					address: !!this.form.fields.address ? this.form.fields.address.toString().toUpperCase() : null,
					last_name: !!this.form.fields.last_name ? this.form.fields.last_name.toString().toUpperCase() : null,
					parcel_id: !!this.form.fields.parcel_id ? this.form.fields.parcel_id!.toString().toUpperCase() : null,
				};
			},
		},

		filters: {
			formatCurrency(val: string) {
				return helpers.formatCurrency(val);
			},
		},

		components: {
			CalculateYourTaxesDetail,
			LevyEstimatorDetail,
			HomesteadExemptionDetail,
			SchoolDistrictEstimateDetail,
			OwnerOccupancyCreditDetail,
			ReevaluationDetail,
		},
	});
